<template>
    <article class="result-card">
        <div class="result-card__image" v-if="!hideImage">
            <thumbnail-image :photo-id="resultItem.Image.Id" v-if="resultItem.Image"></thumbnail-image>
        </div>
        <div class="result-card__inner flow">
            <div class="result-card__header">
                <h3 class="result-card__title">
                    <a :href="resultItem.Link.Url">
                        {{resultItem.Heading}}
                    </a>
                </h3>
                <span class="visually-hidden">Report</span>
            </div>
            <div class="result-card__content flow max-width-s">
                <time :datetime="resultItem.Date.DateTime"><strong>{{formatDate(resultItem.Date.DateTime)}}</strong></time>
                <p>{{truncate(resultItem.Summary)}}</p>
            </div>
            <div class="result-card__footer">
                <a :href="resultItem.Link.Url" class="btn">
                    Find out more
                    <span class="visually-hidden"> about {{resultItem.Heading}}</span>
                </a>
                <profile-actions :page-id="resultItem.Id.toString()"></profile-actions>
            </div>
        </div>
    </article>
</template>

<script>
    import Globals from '@/globals.js'
    import ProfileActions from '@/components/Utils/profile-actions'
    import ThumbnailImage from '@/components/Utils/thumbnail-image'

    import { format, toDate } from '@/utils/date.js'
    import { globalMixin } from '@/mixins/globalMixin.js'
    import { truncate } from '@/utils/strings.js'

    export default {
        components: {
            ProfileActions,
            ThumbnailImage
        },

        methods: {
            formatDate(date) {
                return format(toDate(date), Globals.dateFormatUi)
            },

            truncate: function (stringToTruncate) {
                return truncate(stringToTruncate)
            }
        },

        mixins: [globalMixin],

        props: {
            resultItem: {
                required: true,
                type: Object
            },
            hideImage: {
                required: false,
                type: Boolean
            },
        }
    }
</script>